export const BLOCKED_NOTICE_TITLE = 'This document is blocked';

export const BLOCKED_NOTICE_BODY =
  'Malware scanning reported this file as malicious, so its content is not loaded. Downloading, printing and opening it in a new tab are unavailable.';

export const BLOCKED_NOTICE_HINT = 'Contact your administrator if you believe this is incorrect.';
